import CrudActionSetBase from './CrudActionSetBase'

export class TagValueActionSet extends CrudActionSetBase('tagValue'){}
export default new TagValueActionSet()